import { HttpClient } from '@adapters/HttpClient';

export interface TeamChild {
  id: number;
  name: string;
}

export class TeamsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getTeamsChild(perPage = 100): Promise<TeamChild[]> {
    const response = await this.httpClient.get('/teams-child', { per_page: perPage });
    return response.data;
  }
}
